import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../../config/api';
import './AdminTables.css';

const AdminReports = () => {
  const [reportType, setReportType] = useState('bookings');
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    setLoading(true);
    setError(null);
    const endpoint = reportType === 'bookings' ? '/api/admin/reports/bookings' : '/api/admin/reports/revenue';
    fetch(getApiUrl(endpoint), { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((json) => {
        if (json.success) setReport(json.report || []);
        else setError(json.message);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [reportType]);

  const downloadCsv = () => {
    const headers = reportType === 'bookings'
      ? ['Date', 'Bookings', 'Total revenue']
      : ['Date', 'Revenue', 'Commission', 'Host payout', 'Transactions'];
    const rows = report.map((r) =>
      reportType === 'bookings'
        ? [r._id, r.count, r.totalRevenue]
        : [r._id, r.revenue, r.commission, r.hostPayout, r.count]
    );
    const csv = [headers.join(','), ...rows.map((row) => row.join(','))].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `admin-${reportType}-report.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="admin-page">
      <h2 className="admin-page-title">Reports & Analytics</h2>
      <p className="admin-page-subtitle">Booking and revenue reports. Download as CSV.</p>
      {error && <div className="admin-page-error">{error}</div>}

      <div className="admin-tabs">
        <button type="button" className={reportType === 'bookings' ? 'active' : ''} onClick={() => setReportType('bookings')}>
          Booking report
        </button>
        <button type="button" className={reportType === 'revenue' ? 'active' : ''} onClick={() => setReportType('revenue')}>
          Revenue & commission report
        </button>
      </div>

      <div className="admin-reports-actions">
        <button type="button" className="admin-download-btn" onClick={downloadCsv} disabled={loading || report.length === 0}>
          Download CSV
        </button>
      </div>

      {loading && <div className="admin-page-loading"><div className="admin-spinner" /></div>}
      {!loading && (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Date</th>
                {reportType === 'bookings' ? (
                  <>
                    <th>Bookings</th>
                    <th>Total revenue (₹)</th>
                  </>
                ) : (
                  <>
                    <th>Revenue (₹)</th>
                    <th>Commission (₹)</th>
                    <th>Host payout (₹)</th>
                    <th>Transactions</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {report.map((r) => (
                <tr key={r._id}>
                  <td>{r._id}</td>
                  {reportType === 'bookings' ? (
                    <>
                      <td>{r.count}</td>
                      <td>{(r.totalRevenue ?? 0).toLocaleString()}</td>
                    </>
                  ) : (
                    <>
                      <td>{(r.revenue ?? 0).toLocaleString()}</td>
                      <td>{(r.commission ?? 0).toLocaleString()}</td>
                      <td>{(r.hostPayout ?? 0).toLocaleString()}</td>
                      <td>{r.count}</td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminReports;
